// extracted by mini-css-extract-plugin
export default {"quote":"quote_quote__anpYx","quote_animate":"quote_quote_animate__UmI5c"};